module.exports = __webpack_public_path__ + "static/media/029.67c1091c.jpg";